import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AdminCoupons from './AdminCoupons';
import AdminSales from './AdminSales';
import './AdminPromotions.css';

const AdminPromotions: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'coupons' | 'sales'>('coupons');

  useEffect(() => {
    // Set tab based on current route
    if (location.pathname.includes('/coupons')) {
      setActiveTab('coupons');
    } else if (location.pathname.includes('/sales')) {
      setActiveTab('sales');
    }
  }, [location]);

  const handleTabChange = (tab: 'coupons' | 'sales'): void => {
    setActiveTab(tab);
    navigate(`/admin/promotions`);
  };

  return (
    <div className="admin-promotions">
      <div className="promotions-header">
        <h1>Promotions Management</h1>
        <div className="promotions-tabs">
          <button
            className={`tab-button ${activeTab === 'coupons' ? 'active' : ''}`}
            onClick={() => handleTabChange('coupons')}
          >
            <i className="fas fa-ticket-alt"></i> Coupons
          </button>
          <button
            className={`tab-button ${activeTab === 'sales' ? 'active' : ''}`}
            onClick={() => handleTabChange('sales')}
          >
            <i className="fas fa-tags"></i> Sales
          </button>
        </div>
      </div>

      <div className="promotions-content">
        {activeTab === 'coupons' && <AdminCoupons />}
        {activeTab === 'sales' && <AdminSales />}
      </div>
    </div>
  );
};

export default AdminPromotions;
